import Button from 'src/Components/Button'
import FavoriteButton from './FavoriteButton'
import DirectMessageButton from './DirectMessageButton'
import Listings from './Listings'

const ListingsButton = Listings

Object.assign(Button, {
  Listings: Listings,
  Favorite: FavoriteButton,
  DirectMessage: DirectMessageButton
})

export default Button
export { ListingsButton, FavoriteButton, DirectMessageButton }
